module.exports = __webpack_public_path__ + "media/warranty/proof-doc-icon-0522d56b.png";